export const TRADE_TYPES = [
  // Construction & Building
  'General Contractor',
  'Carpenter',
  'Electrician',
  'Plumber',
  'HVAC',
  'Painter',
  'Roofer',
  'Flooring',
  'Mason',
  'Landscaper',
  'Welder',
  'Pool Service',
  // Automotive
  'Auto Mechanic',
  'Auto Body',
  // Home Services
  'Handyman',
  'Cleaning Service',
  'Pest Control',
  'Security Systems',
  // Tech & Other
  'IT Services',
  'Other',
];
